import multiguard from 'vue-router-multiguard';
import middleware from '@/router/middleware';

import Reports from '@/views/reports/Reports';

export default {
  path: 'my-reports',
  component: Reports,
  meta: {title: 'My reports'}
};
